<script lang="ts">
  let {
    budget,
    spent,
    currency = "KRW",
  }: {
    budget: number;
    spent: number;
    currency?: string;
  } = $props();

  import { formatCurrency } from "../../lib/utils";

  let progress = $derived(budget > 0 ? Math.min((spent / budget) * 100, 100) : 0);
  let remaining = $derived(budget - spent);

  function getProgressColor(p: number): string {
    if (p < 50) return "var(--color-success)";
    if (p < 80) return "var(--color-warning)";
    return "var(--color-error)";
  }

  function getProgressBgColor(p: number): string {
    if (p < 50) return "var(--color-success-light)";
    if (p < 80) return "var(--color-warning-light)";
    return "var(--color-error-light)";
  }

</script>

<div class="space-y-4">
  <!-- Progress Bar -->
  <div>
    <div class="flex justify-between text-sm mb-2">
      <span class="budget-progress__meta">사용 금액</span>
      <span class="font-medium budget-progress__title">{progress.toFixed(1)}%</span>
    </div>
    <div class="w-full h-4 rounded-full" style="background: {getProgressBgColor(progress)};">
      <div
        class="h-4 rounded-full transition-all duration-500"
        style="width: {progress}%; background: {getProgressColor(progress)};"
      ></div>
    </div>
  </div>

  <!-- Status Message -->
  <div class="text-center">
    {#if remaining > 0}
      <p class="text-sm">
        <span class="budget-progress__meta">예산이 </span><span class="font-semibold budget-progress__success">₩{formatCurrency(remaining)}</span><span class="budget-progress__meta"> 남았습니다.</span>
      </p>
    {:else if remaining === 0}
      <p class="text-sm font-medium budget-progress__warning">
        예산을 모두 사용했습니다.
      </p>
    {:else}
      <p class="text-sm font-medium budget-progress__error">
        예산을 ₩{formatCurrency(Math.abs(remaining))} 초과했습니다!
      </p>
    {/if}
  </div>
</div>

<style>
  .budget-progress__title { color: var(--text-primary); }
  .budget-progress__meta { color: var(--text-secondary); }
  .budget-progress__success { color: var(--color-success); }
  .budget-progress__warning { color: var(--color-warning); }
  .budget-progress__error { color: var(--color-error); }
</style>
